import { ReactElement, cloneElement, isValidElement } from 'react';
import { SxProps } from '@mui/material/styles';

type PrintFieldProps = {
  editable?: boolean;
  children: ReactElement;
};

const pdfReadOnlySx: SxProps = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'inherit',
    color: 'text.primary',
  },
  '& .MuiInputBase-adornedStart': {
    marginLeft: '-14px',
  },
  '& .MuiInputAdornment-root *': {
    color: 'text.primary',
  },
  '& .MuiInputLabel-root': {
    color: 'text.primary',
  },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: 'text.primary',
    transform: 'translate(0, -9px) scale(0.75)',
  },
};

export const PrintField = ({ editable = false, children }: PrintFieldProps) => {
  if (!isValidElement(children)) {
    return children;
  }

  const childProps = children.props as {
    sx?: SxProps;
    disabled?: boolean;
  };

  return cloneElement(children, {
    disabled: !editable || childProps.disabled,
    sx: editable ? childProps.sx : [pdfReadOnlySx, childProps.sx],
  });
};
